import type { PiniaPluginContext } from 'pinia';

export default function resetStore({ store }: PiniaPluginContext) {
  const initialState = structuredClone(store.$state);
  store.$reset = () => store.$patch(structuredClone(initialState));
}
